




















































































import {Vue, Component} from 'vue-property-decorator';
import {Getter} from 'vuex-class';
import SearchCategoryForm from '@/views/statistic/sales/category/SearchCategoryForm.vue';
import ItemTable from '@/views/statistic/sales/category/ItemTable.vue';
import {Mall, GetStatisticsSalesCategory, GetStatisticsSalesCategorySummary, GetStatisticsSalesCategoryRequest} from 'supporter';
import {i18nInObjectList} from '@/utils/i18n';
import TuiGrid from 'tui-grid';
import {changeDateFormat} from '@/utils/dateUtils';
import {createExcel} from '@/components/common/grid/ExcelCreateUtil';
import ExcelCreateButton from '@/components/common/grid/ExcelCreateButton.vue';
@Component({
  components: {SearchCategoryForm, ItemTable, ExcelCreateButton}
})
export default class SalesStatistic extends Vue {
  private strSearchRequest: string = '';
  private totalData: any[] = [];
  private detailData: any[] = [];
  private contentBottomOption = {
    havePageSizeBtn: false
  };
  private option = {
    pageSize: 100
  }

  /** 화폐단위 추가 */
  private addCurrencyCode({ value, currencyCode = 'KRW' }: { value: any, currencyCode?: string}) {
    if (value == null || isNaN(value) || Number(value) === 0) {
      return `0 ${currencyCode === 'KRW' ? '원' : currencyCode}`;
    }

    return `${value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')} ${currencyCode === 'KRW' ? '원' : currencyCode}`;
  }

  private gridProps = {
    columns: [
      {
        header: 'STATISTIC_SALES_TOTALORDERCNT',
        name: 'totalOrderCnt',
        align: 'center',
        formatter: function(cell: any) {
          if (cell.row.totalOrderCnt == null || isNaN(cell.row.totalOrderCnt)) {
            return 0;
          }
          return cell.row.totalOrderCnt.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        },
        copyOptions: {
          useFormattedValue: true,
        }
      },
      {
        header: 'STATISTIC_SALES_TOTALPRODUCTCNT',
        name: 'totalProductCnt',
        align: 'center',
        formatter: function(cell: any) {
          if (cell.row.totalProductCnt == null || isNaN(cell.row.totalProductCnt)) {
            return 0;
          }
          return cell.row.totalProductCnt.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        },
        copyOptions: {
          useFormattedValue: true,
        }
      },
      {
        header: 'STATISTIC_SALES_TOTALSALECNT',
        name: 'totalSaleCnt',
        align: 'center',
        formatter: function(cell: any) {
          if (cell.row.totalSaleCnt == null || isNaN(cell.row.totalSaleCnt)) {
            return 0;
          }
          return cell.row.totalSaleCnt.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        },
        copyOptions: {
          useFormattedValue: true,
        }
      },
      {
        header: 'STATISTIC_SALES_TOTALSALEAMT',
        name: 'totalSaleAmt',
        align: 'right',
        formatter: (data: any) => this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode }),
        copyOptions: {
          useFormattedValue: true,
        }
      },
      {
        header: 'STATISTIC_SALES_TOTALPRODUCTPROMOTIONDISCOUNTAMT',
        name: 'totalProductPromotionDiscountAmt',
        align: 'right',
        formatter: (data: any) => this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode }),
        copyOptions: {
          useFormattedValue: true,
        }
      },
      {
        header: 'STATISTIC_SALES_TOTALPRODUCTSALEAMT',
        name: 'totalProductSaleAmt',
        align: 'right',
        formatter: (data: any) => this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode }),
        copyOptions: {
          useFormattedValue: true,
        }
      },
      {
        header: 'STATISTIC_SALES_EXCELBTN',
        name: 'excelBtn',
        align: 'center',
        formatter: function(cell: any) {
          return `<button type="button" class="excelBtn exceCategorylAll" data-start-ymd="${cell.row.startYMD}" data-end-ymd="${cell.row.endYMD}" data-download-type="ALL">${window.$t('COMMON_DOWNLOAD')}</button>`;
        }
      }
    ],
    options: {
      columnOptions: {
        resizable: true
      },
      minBodyHeight: 36,
      scrollX: false,
      scrollY: false,
    }
  };
  private gridPropsDetail = {
    columns: [
      {
        header: 'STATISTIC_SALES_CATEGORYNAME',
        name: 'categoryName',
        minWidth: 180,
        align: 'left'
      },
      {
        header: 'STATISTIC_SALES_TOTALORDERCNT',
        name: 'totalOrderCnt',
        minWidth: 80,
        align: 'center',
        formatter: function(cell: any) {
          if (cell.row.totalOrderCnt == null || isNaN(cell.row.totalOrderCnt)) {
            return 0;
          }
          return cell.row.totalOrderCnt.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        },
        copyOptions: {
          useFormattedValue: true,
        }
      },
      {
        header: 'STATISTIC_SALES_TOTALPRODUCTCNT',
        name: 'totalProductCnt',
        minWidth: 80,
        align: 'center',
        formatter: function(cell: any) {
          if (cell.row.totalProductCnt == null || isNaN(cell.row.totalProductCnt)) {
            return 0;
          }
          return cell.row.totalProductCnt.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        },
        copyOptions: {
          useFormattedValue: true,
        }
      },
      {
        header: 'STATISTIC_SALES_TOTALSALECNT',
        name: 'totalSaleCnt',
        minWidth: 80,
        align: 'center',
        formatter: function(cell: any) {
          if (cell.row.totalSaleCnt == null || isNaN(cell.row.totalSaleCnt)) {
            return 0;
          }
          return cell.row.totalSaleCnt.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        },
        copyOptions: {
          useFormattedValue: true,
        }
      },
      {
        header: 'STATISTIC_SALES_TOTALSALEAMT',
        name: 'totalSaleAmt',
        minWidth: 110,
        align: 'right',
        formatter: (data: any) => this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode }),
        copyOptions: {
          useFormattedValue: true,
        }
      },
      {
        header: 'STATISTIC_SALES_TOTALCOMMISSIONAMT',
        name: 'totalCommissionAmt',
        minWidth: 120,
        align: 'right',
        formatter: (data: any) => this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode }),
        copyOptions: {
          useFormattedValue: true,
        }
      },
      {
        header: 'STATISTIC_SALES_TOTALMALLPROMOTIONAMT',
        name: 'totalMallPromotionAmt',
        minWidth: 180,
        align: 'right',
        formatter: (data: any) => this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode }),
        copyOptions: {
          useFormattedValue: true,
        }
      },
      {
        header: 'STATISTIC_SALES_TOTALPARTNERPROMOTIONAMT',
        name: 'totalPartnerPromotionAmt',
        minWidth: 180,
        align: 'right',
        formatter: (data: any) => this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode }),
        copyOptions: {
          useFormattedValue: true,
        }
      },
      {
        header: 'STATISTIC_SALES_TOTALPAYAMT',
        name: 'totalPayAmt',
        minWidth: 180,
        align: 'right',
        formatter: (data: any) => this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode }),
        copyOptions: {
          useFormattedValue: true,
        }
      },
      {
        header: 'STATISTIC_SALES_TOTALMALLPROFITAMT',
        name: 'totalMallProfitAmt',
        minWidth: 180,
        align: 'right',
        formatter: (data: any) => this.addCurrencyCode({ value: data.value, currencyCode: data.row.currencyCode }),
        copyOptions: {
          useFormattedValue: true,
        }
      },
      {
        header: 'STATISTIC_SALES_EXCELBTN',
        name: 'excelBtn',
        minWidth: 100,
        align: 'center',
        formatter: function(cell: any) {
          return `<button type="button" class="excelBtn excelCategoryDetail" data-start-ymd="${cell.row.startYMD}" data-end-ymd="${cell.row.endYMD}" data-category-no="${cell.row.categoryNo}" data-product-no="${cell.row.mallOptionNo}" data-category-depth="${cell.row.categoryDepth}" data-download-type="UNIT" data-date-type="PERIOD">${window.$t('COMMON_DOWNLOAD')}</button>`;
        }
      }
    ],
    options: {
      columnOptions: {
        resizable: true
      },
      scrollX: true,
      pageOptions: {
        perPage: 30,
        page: 1,
        totalCount: 0
      }
    }
  };
  private get statisticsCategoryExtraInfo() {
    const request = this.strSearchRequest ? JSON.parse(this.strSearchRequest) : {};
    const startYmd = request?.params?.startYmd ?? '';
    const endYmd = request?.params?.endYmd ?? '';

    return `${changeDateFormat(startYmd, 'YYYYMMDD')}_${changeDateFormat(endYmd, 'YYYYMMDD')}`
  }

  private search(page: number = 1, size: number) {
    const noData = this.$t('STATISTIC_SALES_PERIOD_SEARCH_NODATA') as string;
    TuiGrid.setLanguage('ko', {
      display: {
        noData
      }
    });
    const searchForm: any = this.$refs.searchCategoryForm;
    searchForm.searchBtnClick(page, size);
  }
   private bodyheight:number = 130
  private startYMD: string = '';
  private endYMD: string = '';
  private mallName: string = '';
  private totalCount: number = 0;
  private setData(categorycontents: GetStatisticsSalesCategory, categorySummarycontents: GetStatisticsSalesCategorySummary, page: number, size: number, mallName: string) {
    const noData = this.$t('STATISTIC_SALES_PERIOD_SEARCH_NODATA') as string;
    TuiGrid.setLanguage('ko', {
      display: {
        noData
      }
    });
    this.startYMD = categorySummarycontents.startYmd;
    this.endYMD = categorySummarycontents.endYmd;
    // if (new Date(this.endYMD.replace(/-/g, '/')).getMonth() == new Date().getMonth()){
    //   this.endYMD = changeDateFormat(new Date(), 'YYYY-MM-DD')
    // }
    this.mallName = mallName;
    const currencyCode = categorySummarycontents.currencyCode;
    const arry: any[] = [];
    const val = {
      totalOrderCnt: categorySummarycontents.summary.totalOrderCnt,
      totalProductCnt: categorySummarycontents.summary.totalProductCnt,
      totalSaleCnt: categorySummarycontents.summary.totalSaleCnt,
      totalSaleAmt: categorySummarycontents.summary.totalSaleAmt,
      totalProductPromotionDiscountAmt: categorySummarycontents.summary.totalProductPromotionDiscountAmt,
      totalProductSaleAmt: categorySummarycontents.summary.totalProductSaleAmt,
      startYMD: this.startYMD,
      endYMD: this.endYMD,
      currencyCode,
    };
    arry.push(val);

    this.totalData = arry;
    if (this.totalData.length > 0){
      this.bodyheight = 31
    } else {
      this.bodyheight = 130
    }
    this.detailData = categorycontents.contents.map(contentitem => {
      return {...contentitem, startYMD: this.startYMD, endYMD: this.endYMD};
    });
    this.gridPropsDetail.options.pageOptions.page = page;
    this.gridPropsDetail.options.pageOptions.perPage = size;
    this.gridPropsDetail.options.pageOptions.totalCount = categorycontents.totalCount;
    this.totalCount = categorycontents.totalCount;
  }
  private created() {
    const noData = this.$t('STATISTIC_SALES_PERIOD_INIT_NODATA') as string;
    TuiGrid.setLanguage('ko', {
      display: {
        noData
      }
    });
    this.isNaberPayMall();
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
    this.gridPropsDetail = i18nInObjectList(this, this.gridPropsDetail, 'columns', 'header');
  }

  private useNaverPay: boolean = false;
  @Getter('malls', {namespace: 'mall'})
  private malls!: Mall[];
  private async isNaberPayMall() {
    this.malls.forEach((item: any) => {
      this.setIsNaverPayMall(item.mallNo);
    });
  }
  private setIsNaverPayMall(mallNo: number) {
    const orderConfigRequest = {
      pathParams: {
        mallNo: String(mallNo)
      },
      params: {
        key: 'ORDER_CONFIG' // 결제수단 조회
      }
    };
    this.$api.getMallsConfigurations(orderConfigRequest).then(ret => {
      if (ret && ret.data) {
        this.useNaverPay = this.useNaverPay || ret.data.useNaverPay;
      }
    });
  }

  private beforeDestroy(){
    $('body').off('click', '.exceCategorylAll', $.proxy(this.exceCategorylAll, this));
    $('body').off('click', '.excelCategoryDetail', $.proxy(this.excelCategoryDetail, this));
  }

  private async mounted() {
    $('body').on('click', '.exceCategorylAll', $.proxy(this.exceCategorylAll, this));
    $('body').on('click', '.excelCategoryDetail', $.proxy(this.excelCategoryDetail, this));
  }
  private excelCategoryDetail(e:any){
    const dateNow = new Date().getTime();
    const excelDownRequest: any = {
      params: {
        categoryDepth: '', //  要搜索的类别深度
        categoryNo: '', //  类别号
        couponType: '', //  优惠券类型
        displayBrandNo: '', //  展览品牌号
        displayCategoryNo: '', //  展览分类号
        endYmd: '', // *  结束日期
        genderTypes: '', // *  会员性别
        includesClaim: '', //  클레임구분
        keyword: '', //  검색어 입력
        mallNo: '', // * mall
        memberGradeNo: '', //  会员等级
        memberGroupNo: '', //  会员组
        memberType: '', // * 会员类型
        page: '', // * page
        partnerNo: '', //  파트너번호
        payType: '', //  支付手段
        platformTypes: '', // * 平台类型（pc web app）
        productNos: '', // 商品编号列表
        productType: '', //  商品查询标准
        promotionKeywordType: '', //  促销搜索关键字类型
        promotionType: '', //  宣传搜索类型
        saleMethodType: '', //  销售方式区分
        size: '', // * size
        startYmd: '', // *  开始日期
        discountNo: null
      }
    };
    const searchRequest:GetStatisticsSalesCategoryRequest = JSON.parse(this.strSearchRequest)
      excelDownRequest.params.categoryDepth = $(e.target).data('categoryDepth')
      excelDownRequest.params.categoryNo = $(e.target).data('categoryNo')
      excelDownRequest.params.displayBrandNo = searchRequest.params.displayBrandNo
      excelDownRequest.params.displayCategoryNo = searchRequest.params.displayCategoryNo
      excelDownRequest.params.endYmd = searchRequest.params.endYmd
      excelDownRequest.params.genderTypes = searchRequest.params.genderTypes
      excelDownRequest.params.includesClaim = searchRequest.params.includesClaim
      excelDownRequest.params.mallNo = searchRequest.params.mallNo
      excelDownRequest.params.memberGradeNo = searchRequest.params.memberGradeNo
      excelDownRequest.params.memberGroupNo = searchRequest.params.memberGroupNo
      excelDownRequest.params.memberType = searchRequest.params.memberType
      excelDownRequest.params.page = '1';
      excelDownRequest.params.size = '30';
      excelDownRequest.params.partnerNo = searchRequest.params.partnerNo
      excelDownRequest.params.payType = searchRequest.params.payType
      excelDownRequest.params.platformTypes = searchRequest.params.platformTypes
      // excelDownRequest.params.productNos = $(e.target).data('productNo')
      // excelDownRequest.params.productType = searchRequest.params.productType
      excelDownRequest.params.saleMethodType = searchRequest.params.saleMethodType
      excelDownRequest.params.startYmd = searchRequest.params.startYmd

      // let fileName = `Sales_Statistic_${excelDownRequest.params.startYmd}_${excelDownRequest.params.endYmd}${dateNow}.xlsx`;
      const endYmd = new Date(searchRequest.params.endYmd.replace(/-/g, '/')).getMonth() == new Date().getMonth()?changeDateFormat(new Date(), 'YYYY-MM-DD'):searchRequest.params.endYmd
      createExcel(this, this.detailData.length > 0, excelDownRequest.params, 'PREMIUM_STATISTICS_SALE_CATEGORY_DETAIL', $(e.target).data('categoryNo')+'_'+changeDateFormat(excelDownRequest.params.startYmd, 'YYYYMMDD') + '_' + changeDateFormat(endYmd, 'YYYYMMDD'));
      // let fileName = 'Sales_Statistic_'+ changeDateFormat(excelDownRequest.params.startYmd, 'YYYYMMDD')+ '_'+ changeDateFormat(endYmd, 'YYYYMMDD')+`_${new Date().getTime()}.xlsx`;
      // this.$api.getStatisticsExcel(excelDownRequest).then((res) => {
      //   let blob = new window.Blob([res.data], {type: 'blob'});
      //   if ('download' in document.createElement('a')) {
      //     // 非IE下载
      //     let elink = document.createElement('a');
      //     elink.download = fileName;
      //     elink.style.display = 'none';
      //     elink.href = URL.createObjectURL(blob);
      //     document.body.appendChild(elink);
      //     elink.click();
      //     URL.revokeObjectURL(elink.href); // 释放URL 对象
      //     document.body.removeChild(elink);
      //   } else {
      //     // IE10+下载
      //     navigator.msSaveBlob(blob, fileName);
      //   }
      // });
  }
  private exceCategorylAll(){
    const dateNow = new Date().getTime();
    const excelDownRequest: any = {
      params: {
        categoryDepth: '', //  要搜索的类别深度
        categoryNo: '', //  类别号
        couponType: '', //  优惠券类型
        displayBrandNo: '', //  展览品牌号
        displayCategoryNo: '', //  展览分类号
        endYmd: '', // *  结束日期
        genderTypes: '', // *  会员性别
        includesClaim: '', //  클레임구분
        keyword: '', //  검색어 입력
        mallNo: '', // * mall
        memberGradeNo: '', //  会员等级
        memberGroupNo: '', //  会员组
        memberType: '', // * 会员类型
        page: '', // * page
        partnerNo: '', //  파트너번호
        payType: '', //  支付手段
        platformTypes: '', // * 平台类型（pc web app）
        productNos: '', // 商品编号列表
        productType: '', //  商品查询标准
        promotionKeywordType: '', //  促销搜索关键字类型
        promotionType: '', //  宣传搜索类型
        saleMethodType: '', //  销售方式区分
        size: '', // * size
        startYmd: '', // *  开始日期
        discountNo: null
      }
    };
    const searchRequest:GetStatisticsSalesCategoryRequest = JSON.parse(this.strSearchRequest)

    if (searchRequest.params.memberGradeNo == '0'){
      searchRequest.params.memberGradeNo = ''
    }
    if (searchRequest.params.memberGroupNo == '0'){
      searchRequest.params.memberGroupNo = ''
    }
      excelDownRequest.params.categoryDepth = searchRequest.params.categoryDepth
      excelDownRequest.params.categoryNo = searchRequest.params.categoryNo
      excelDownRequest.params.displayBrandNo = searchRequest.params.displayBrandNo
      excelDownRequest.params.displayCategoryNo = searchRequest.params.displayCategoryNo
      excelDownRequest.params.endYmd = searchRequest.params.endYmd
      excelDownRequest.params.genderTypes = searchRequest.params.genderTypes
      excelDownRequest.params.includesClaim = searchRequest.params.includesClaim
      excelDownRequest.params.mallNo = searchRequest.params.mallNo
      excelDownRequest.params.memberGradeNo = searchRequest.params.memberGradeNo
      excelDownRequest.params.memberGroupNo = searchRequest.params.memberGroupNo
      excelDownRequest.params.memberType = searchRequest.params.memberType
      excelDownRequest.params.page = '1';
      excelDownRequest.params.size = '30';
      excelDownRequest.params.partnerNo = searchRequest.params.partnerNo
      excelDownRequest.params.payType = searchRequest.params.payType
      excelDownRequest.params.platformTypes = searchRequest.params.platformTypes
      excelDownRequest.params.productNos = searchRequest.params.productNos
      excelDownRequest.params.productType = searchRequest.params.productType
      excelDownRequest.params.saleMethodType = searchRequest.params.saleMethodType
      excelDownRequest.params.startYmd = searchRequest.params.startYmd
      const endYmd = new Date(searchRequest.params.endYmd.replace(/-/g, '/')).getMonth() == new Date().getMonth()?changeDateFormat(new Date(), 'YYYY-MM-DD'):searchRequest.params.endYmd
      createExcel(this, this.detailData.length > 0, excelDownRequest.params, 'PREMIUM_STATISTICS_SALE_CATEGORY_PERIOD', changeDateFormat(excelDownRequest.params.startYmd, 'YYYYMMDD') + '_' + changeDateFormat(endYmd, 'YYYYMMDD'));
      // let fileName = 'Sales_Statistic_'+ changeDateFormat(excelDownRequest.params.startYmd, 'YYYYMMDD')+ '_'+ changeDateFormat(endYmd, 'YYYYMMDD')+`_${new Date().getTime()}.xlsx`;
      // this.$api.getStatisticsExcel(excelDownRequest).then((res) => {
      //   let blob = new window.Blob([res.data], {type: 'blob'});
      //   if ('download' in document.createElement('a')) {
      //     // 非IE下载
      //     let elink = document.createElement('a');
      //     elink.download = fileName;
      //     elink.style.display = 'none';
      //     elink.href = URL.createObjectURL(blob);
      //     document.body.appendChild(elink);
      //     elink.click();
      //     URL.revokeObjectURL(elink.href); // 释放URL 对象
      //     document.body.removeChild(elink);
      //   } else {
      //     // IE10+下载
      //     navigator.msSaveBlob(blob, fileName);
      //   }
      // });
  }

  private setSearchRequest(request:string){
    this.strSearchRequest = request
  }

  private onTabClick(urlPath:string){
    if (this.$route.path === urlPath) {
        this.$router.go(0);
        return;
    }

    this.$router.push({
        path: urlPath,
      });
  }
}
